export default __webpack_public_path__ + "static/talkSealights-618f6a6cb0d72a5e55ea300fb9606397.png";